import React from 'react'
import './Rbu.css'
import { FaChevronRight } from 'react-icons/fa'
import rbuimg from '../../../../assets/img/360.svg'
import { useNavigate } from 'react-router-dom';

function Rbu() {
  const navigate = useNavigate();
  return (
    <section className='rbu'>
       <div className='container'>
         <div className='rbu-txt'>
           <h4>Ready to build the</h4>
           <h3>Unbuilt?</h3>
           <p>We're here to help. Tell us about your project and we'll
           be in touch.</p>
           <button class="btn-main"  onClick={() => navigate('/contact')}><span>Get a Quote</span> <FaChevronRight/></button>
         </div>  
       </div> 
       <div className='rbu-img'><img src={rbuimg} alt='360 bytes' width={400} height={300} loading="lazy"/></div> 
    </section>
  )
}

export default Rbu
